// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"roles_actions___buttonWrapper___adf5c8ad"};